<script>
	import { onMount } from 'svelte';

	export let reportName = 'Report';
	export let urlFile = '';
	export let dataSetName = '';
	export let data = [];

	let viewer, report, dataSet, options;

	let noRecordsFound = false;

	async function initializeStimulsoft() {
		console.log('🔍 STIMULSOFT_KEY value:', process.env.STIMULSOFT_KEY);
		console.log('🔍 Type of STIMULSOFT_KEY:', typeof process.env.STIMULSOFT_KEY);
		console.log('🔍 window.Stimulsoft exists:', !!window.Stimulsoft);
		console.log('🔍 window.Stimulsoft.Base exists:', !!window.Stimulsoft?.Base);

		if (!process.env.STIMULSOFT_KEY) {
			console.error('❌ STIMULSOFT_KEY is not defined!');
			return;
		}

		// Verifica che Stimulsoft sia caricato
		if (!window.Stimulsoft || !window.Stimulsoft.Base) {
			console.error('❌ Stimulsoft libraries are not loaded!');
			return;
		}

		viewer?.dispose?.();
		
		window.Stimulsoft.Base.StiLicense.key = process.env.STIMULSOFT_KEY;
		
		options = new Stimulsoft.Viewer.StiViewerOptions();
		options.toolbar.showOpenButton = false;
		options.toolbar.showEditorButton = false;
		options.toolbar.showBookmarksButton = false;
		options.toolbar.showParametersButton = false;
		options.toolbar.showResourcesButton = false;
		options.toolbar.viewMode = Stimulsoft.Viewer.StiWebViewMode.Continuous;
		options.appearance.theme = Stimulsoft.Viewer.StiViewerTheme.Office2013WhiteGreen;

		viewer = new window.Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);
		report = new window.Stimulsoft.Report.StiReport();
		dataSet = new Stimulsoft.System.Data.DataSet(dataSetName);
	}

	onMount(async () => {
		await initializeStimulsoft();
		if (document.getElementById('viewer')) {
			if (data) {
				noRecordsFound = false;
				// Load report template content instead of direct URL to avoid null pages
				const response = await fetch(urlFile);
				if (!response.ok) {
					console.error(`❌ Failed to load report template: ${response.status}`);
					return;
				}
				const template = await response.text();
				// Reinitialize report to clear previous pages
				report = new window.Stimulsoft.Report.StiReport();
				// Load report from template string
				report.load(template);
				// Assign report to viewer
				viewer.report = report;
				// Create new DataSet object
				dataSet = new Stimulsoft.System.Data.DataSet(dataSetName);
				//Data to DataSet object
				dataSet.readJson({ [dataSetName]: data });
				// Remove all connections from the report template
				report.dictionary.databases.clear();
				// Register DataSet object
				report.regData(dataSetName, dataSetName, dataSet);
				report.dictionary.synchronize();
				//Report name
				report.reportName = reportName;
				report.ReportAlias = report.ReportName;
				// Generate pages
				//Rendering the viewer to selected element
				viewer.renderHtml('viewer');

			} else {
				document.getElementById('viewer').innerHTML = '';
				noRecordsFound = true;
			}
		}
	});
</script>

{#if noRecordsFound}
	<div class="mt-4 text-center border border-black">
		<span>Nessun record trovato</span>
	</div>
{/if}
<div id="viewer"></div>